import StatBar from "@/components/StatBar";
import AshLogo from "@/components/AshLogo";

export default function HUD({ stats, month, bootstrap }) {
  return (
    <div
      data-testid="game-hud"
      className="pixel-panel-dark space-y-3 sticky top-2 relative"
    >
      <AshLogo size={26} className="absolute -top-1 -right-1 opacity-70" />
      <div className="flex items-center justify-between">
        <div className="pixel-font text-[10px] text-white/80">MONTH</div>
        <div className="pixel-font text-sm md:text-base text-[#F58634]">{month} / 12</div>
      </div>
      <div className="flex items-center justify-between">
        <div className="pixel-font text-[10px] text-white/80">BUDGET</div>
        <div
          className={`vt323 text-2xl tabular-nums ${
            bootstrap ? "text-red-400 pixel-blink" : "text-emerald-300"
          }`}
          data-testid="hud-budget"
        >
          ${stats.budget.toLocaleString()}
        </div>
      </div>
      {bootstrap && (
        <div className="bg-red-500/20 border-2 border-red-400 px-2 py-1 pixel-font text-[9px] text-red-200 text-center">
          BOOTSTRAP MODE
        </div>
      )}
      <div className="space-y-2 pt-1">
        <StatBar label="Awareness" value={stats.awareness} statKey="awareness" />
        <StatBar label="Trust" value={stats.trust} statKey="trust" />
        <StatBar label="Leads" value={stats.leads} statKey="leads" />
        <StatBar label="Energy" value={stats.energy} statKey="energy" />
        <StatBar label="Systems" value={stats.systems} statKey="systems" />
      </div>
    </div>
  );
}
